// src/storageLocation/ui/UploadDocuments.tsx

import React, { useState } from 'react';
import {Avatar, Box, Button, Card, Group, Text} from '@mantine/core';
import { uploadDocument } from '../../../Services/RentContractDocumentService';
import {Dropzone} from "@mantine/dropzone";
import {IconFile, IconPhoto, IconUpload, IconX} from "@tabler/icons-react";

interface UploadDocumentsProps {
    rentContractId: number;
    onUploadSuccess: () => void;
}

export const UploadDocuments: React.FC<UploadDocumentsProps> = ({ rentContractId, onUploadSuccess }) => {
    const [file, setFile] = useState<File | null>(null);
    const [error, setError] = useState<string | null>(null);

    const handleDrop = (files: File[]) => {
        if (files.length > 0) {
            const selectedFile = files[0];
            console.log("File name:", selectedFile.name);
            console.log("File type:", selectedFile.type);
            setFile(selectedFile);
        }
    };

    const handleDeleteFile = () => {
        setFile(null);
    };

    const handleUpload = async () => {
        try {
            if (file && file.size === 0) {
                setError('Bitte wähle eine PDF oder Docx Datei aus');
                return;
            }
            // Validate file size (max 10MB)
            const maxSizeInBytes = 10 * 1024 * 1024; // 10MB
            if (file && file.size > maxSizeInBytes) {
                setError('Dateigröße darf 10MB nicht überschreiten');
                return;
            }

            if(file){
                await uploadDocument(rentContractId, file);
                setFile(null);
                setError(null);
                onUploadSuccess();
            }

        } catch (err) {
            console.error(err);
            setError('Fehler beim hochladen des dokuments');
        }
    };

    return (
        <Group>
            <Dropzone
                onDrop={handleDrop}
                onReject={(files) => console.log('rejected files', files)}
                maxSize={10 * 1024 ** 2}
                accept={["application/pdf", "application/vnd.openxmlformats-officedocument.wordprocessingml.document"]}
                multiple={false}
            >
                <Group justify="center" gap="xl" mih={220} style={{ pointerEvents: 'none' }}>
                    <Dropzone.Accept>
                        <IconUpload size={52} color="var(--mantine-color-blue-6)" stroke={1.5} />
                    </Dropzone.Accept>
                    <Dropzone.Reject>
                        <IconX size={52} color="var(--mantine-color-red-6)" stroke={1.5} />
                    </Dropzone.Reject>
                    <Dropzone.Idle>
                        <IconPhoto size={52} color="var(--mantine-color-dimmed)" stroke={1.5} />
                    </Dropzone.Idle>

                    <div>
                        <Text size="xl" inline>
                            Ziehe das Pdf oder Docx hierhin oder klicke um Datei auszuwählen
                        </Text>
                        <Text size="sm" c="dimmed" inline mt={7}>
                            Füge eine PDF oder Docx Datei hinzu, die nicht 10MB überschreitet
                        </Text>
                    </div>
                </Group>
            </Dropzone>
            {file && (
                <Box mt="md">
                    <Card withBorder shadow="sm" padding="md">
                        <Group align="center">
                            <Avatar size="lg" radius="sm" variant="light">
                                <IconFile size={24} />
                            </Avatar>
                            <div style={{ flex: 1, marginLeft: 10 }}>
                                <Text w={500}>{file.name}</Text>
                            </div>
                            <Button variant="outline" onClick={handleDeleteFile}>
                                Datei nicht mehr auswählen
                            </Button>
                        </Group>
                    </Card>
                </Box>
            )}
            {file && <Button onClick={handleUpload} variant={"filled"}>hochladen</Button>}

            {error && <Text color="red">{error}</Text>}
        </Group>
    );
};
